/**
 * Chat for the book that is already open.
 * Returns null when no book is open, or the open book has no session yet.
 * Callers then use bare /chat.
 */
export function openBookChatPath({
  currentSession = null,
  currentStory = null,
  currentProject = null,
} = {}) {
  const storyId = currentStory?.id || null;
  const projectId = currentProject?.id || null;
  if (!storyId && !projectId) return null;

  const sessionId = currentSession?.id || null;
  const sameStory = Boolean(
    storyId
    && currentSession?.story_id
    && String(currentSession.story_id) === String(storyId),
  );
  const sameProject = Boolean(
    !storyId
    && projectId
    && currentSession?.project_id
    && String(currentSession.project_id) === String(projectId),
  );
  if (sessionId && (sameStory || sameProject)) return `/chat/${sessionId}`;

  const discovery = currentStory?.discovery_session_id || currentProject?.discovery_session_id;
  if (discovery) return `/chat/${discovery}`;
  return null;
}
